import { RouteItem } from '@eastcoal/router/types/route'

import { TRADITION_AUCTION_CREATE_PAGE_PATH } from '../constants/path'

export const traditionAuctionCreateRoute: RouteItem = {
  title: '新增竞拍',
  hideInMenu: true,
  path: TRADITION_AUCTION_CREATE_PAGE_PATH,
  Component: () => import('./index')
}
